<template>
  <!-- Search Filter -->
  <div class="row filter-row">
    <div class="col-sm-6 col-md-3 col-lg-3 col-xl-2 col-12">
      <v-autocomplete v-model="selectedEmployee" :items="employeeOptions" variant="outlined" density="comfortable"
        item-title="text" item-value="text" clearable label="Employee Name" @update:model-value="onSearchClick"></v-autocomplete>
    </div>
    <div class="col-sm-6 col-md-3 col-lg-3 col-xl-2 col-12">
      <v-autocomplete v-model="leaveDayType" :items="SelectType" variant="outlined" density="comfortable" clearable
        label="Leave Type" @update:model-value="onSearchClick"></v-autocomplete>
    </div>
    <div class="col-sm-6 col-md-3 col-lg-3 col-xl-2 col-12">
      <v-autocomplete v-model="leaveStatus" :items="SelectStatus" variant="outlined" density="comfortable" clearable
        label="Leave Status" @update:model-value="onSearchClick"></v-autocomplete>
    </div>
    <div class="col-sm-6 col-md-3 col-lg-3 col-xl-2 col-12">
      <div class="input-block mb-3 form-focus position-relative">
        <label class="position-absolute top-0 start-0 ps-2 pt-1 lh-1 text-black"
          style="z-index: 100; font-size: 12px;">From</label>
        <div class="cal-icon" style="z-index: 90;">
          <date-picker v-model="startDate" placeholder="From" class="form-control floating datetimepicker"
            :editable="true" :clearable="false" :inputFormat="dateFormat" @update:model-value="onSearchClick" />
        </div>
      </div>
    </div>
    <div class="col-sm-6 col-md-3 col-lg-3 col-xl-2 col-12">
      <div class="input-block mb-3 form-focus position-relative">
        <label class="position-absolute top-0 start-0 ps-2 pt-1 lh-1 text-black"
          style="z-index: 100; font-size: 12px;">To</label>
        <div class="cal-icon" style="z-index: 90;">
          <date-picker v-model="endDate" placeholder="To" class="form-control floating datetimepicker" :editable="true"
            :clearable="false" :inputFormat="dateFormat" @update:model-value="onSearchClick" />
        </div>
      </div>
    </div>
  </div>
  <!-- /Search Filter -->
</template>

<script>
import axios from "axios";
import { VUE_APP_API_BASE_URL } from "../config";
import leaveType from "@/views/pages/administration/settings/leave-type.vue";
import leaveSettings from "@/views/pages/employees/leave-settings/leave-settings.vue";
import { dateRangeStart } from "@/utils/util-var";
import { format } from "date-fns";

const today = new Date();
const endOfYear = new Date(today.getFullYear(), 11, 31);
export default {
  computed: {
    leaveSettings() {
      return leaveSettings
    },
    leaveType() {
      return leaveType
    }
  },
  data() {
    return {
      select2: null,
      SelectType: ["Single", "Multiple", "Half"],
      SelectStatus: ["PENDING", "APPROVED", "REJECTED", "HOLD"],
      dateFormat: 'dd/MM/yyyy',
      startDate: dateRangeStart,
      endDate: endOfYear,
      selectedEmployee: null,
      employeeOptions: [],
      leaveDayType: null,
      leaveStatus: null
    };
  },
  mounted() {
    this.getEmployees();
  },
  methods: {
    async getEmployees() {
      await axios.get(`${VUE_APP_API_BASE_URL}/user/user-list`)
        .then((response) => {
          if (response.data.status) {
            this.employeeOptions = response.data.data.map(element => ({
              id: element.id,
              text: `${element.first_name} ${element.last_name}`
            }));
          }
        }).catch(function (error) {
          console.log(error);
        });
    },
    onSearchClick() {
      this.$emit("searchClicked", {
        start_date: format(this.startDate, 'yyyy-MM-dd'),
        end_date: format(this.endDate, 'yyyy-MM-dd'),
        employee_name: this.selectedEmployee,
        leave_type: this.leaveDayType,
        leave_status: this.leaveStatus
      });
    }
  }
};
</script>
